/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-bind */

import React, { useEffect } from 'react';

import ADGMPanelInputsGeneratorBody from 'aurora-components/ADGMPanelInputsGenerator/ADGMPanelInputsGeneratorBody';
import { ADGMResponsiveModal, ADGMPagination, ADGMSnackbar } from 'aurora-components';
import withStyles from '@material-ui/core/styles/withStyles';
import Loading from 'aurora-components/Loading';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { keyEmptyCheck } from 'aurora-utils/utils';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import isObject from 'lodash/isObject';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import UpdateEntity from './updateEntity';
import FetchedEntity from './fetchedEntity';
import useHelpers from './helpers';
import NoResultsScreen from './noResultsScreen';
import { REQUIRED_FIELDS } from './constants';
import styles from './styles';

const ADGMEntityModal = ({
  classes,
  intl,
  isOpen,
  handleClose,
  addEntity,
  updateEntity,
  serviceLabel,
  isEdit,
  entityToUpdate,
  isSecondParty,
}) => {
  const { loading, fetchedEntity, error, noResults } = useSelector(state => state.commonReducer);
  const {
    formData,
    setFormData,
    page,
    activeEntity,
    setActiveEntity,
    entityDetails,
    handleAdd,
    handleUpdate,
    handleInputChange,
    handleFetchDetails,
    handlePageChange,
    SECTION_FIELDS,
    onCloseModal,
  } = useHelpers({
    isSecondParty,
    addEntity,
    updateEntity,
    serviceLabel,
    intl,
    handleClose,
  });

  useEffect(() => {
    setFormData({ ...entityToUpdate });
  }, [entityToUpdate]);

  return (
    <ADGMResponsiveModal
      open={isOpen}
      toggleModal={onCloseModal}
      onClose={onCloseModal}
      classes={{ modalTitleHead: classes.modalTitleHead }}
      title={isEdit ? keyEmptyCheck('edit_party_details') : keyEmptyCheck('add_entity', { entity: serviceLabel })}
    >
      <div className={classes.innerModal}>
        {loading && <Loading />}
        {error && (
          <ADGMSnackbar
            message={isObject(keyEmptyCheck(error?.message)) ? keyEmptyCheck(error?.message) : error?.message}
          />
        )}
        <Grid container spacing={3} className={classes.gridContainer}>
          {isEdit ? (
            <UpdateEntity formData={formData} handleInputChange={handleInputChange} />
          ) : (
            <>
              <Grid item xs={12} md={12}>
                <ADGMPanelInputsGeneratorBody
                  isEditable
                  title=''
                  sections={SECTION_FIELDS}
                  classes={{
                    containerPadding: classes.modalContainerModified,
                    sectionTitle: classes.modalSectionTittle,
                    titleWrapper: classes.modalTitleWrapper,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} className={classes.btnContainer}>
                <Button
                  onClick={() =>
                    handleFetchDetails({
                      pageNum: 0,
                    })
                  }
                  className={classNames(classes.blckBtn, classes.btnCls)}
                  variant='contained'
                  disabled={!REQUIRED_FIELDS[formData?.type]?.every(field => formData[field])}
                >
                  {keyEmptyCheck('get_details')}
                </Button>
              </Grid>
            </>
          )}
          {entityDetails?.length > 0 && (
            <Grid item xs={12} md={12}>
              {!isEdit &&
                entityDetails.map((entity, index) => (
                  <FetchedEntity
                    key={index}
                    entityDetails={entity}
                    serviceLabel={serviceLabel}
                    activeEntity={activeEntity}
                    setActiveEntity={setActiveEntity}
                  />
                ))}
              {formData?.type === 'GOVERNMENT_ENTITY' && fetchedEntity?.totalPages > 1 && (
                <ADGMPagination
                  totalPages={fetchedEntity?.totalPages - 1}
                  currentPage={Number(page)}
                  onPageChange={handlePageChange}
                />
              )}
            </Grid>
          )}
          {noResults && (
            <NoResultsScreen
              showCompanyIcon={!!(formData?.type === 'GOVERNMENT_ENTITY' || formData?.type === 'COMPANY')}
            />
          )}
          {(entityDetails?.length > 0 || isEdit) && (
            <Grid item xs={12} md={12} className={classes.footer}>
              <Button onClick={onCloseModal} className={classNames(classes.btnCls)} variant='outlined'>
                {keyEmptyCheck('cancel')}
              </Button>
              <Button
                onClick={isEdit ? handleUpdate : handleAdd}
                className={classNames(classes.redBtn, classes.btnCls)}
                variant='contained'
              >
                {keyEmptyCheck(isEdit ? 'submit_changes' : 'add_entity', { entity: serviceLabel })}
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </ADGMResponsiveModal>
  );
};

ADGMEntityModal.propTypes = {
  intl: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  addEntity: PropTypes.func.isRequired,
  updateEntity: PropTypes.func.isRequired,
  serviceLabel: PropTypes.string.isRequired,
  isEdit: PropTypes.bool.isRequired,
  entityToUpdate: PropTypes.object,
  isSecondParty: PropTypes.bool,
};

ADGMEntityModal.defaultProps = {
  entityToUpdate: {},
  isSecondParty: false,
};
export default withStyles(styles)(injectIntl(ADGMEntityModal));
